<template>
  <div class="d-flex flex-column empty-report text-center w-100">
    <span class="icon pb-3 far fa-file-alt"></span>
    Please select a report
  </div>
</template>

<script>
export default {
  name: 'DefaultReport'
}
</script>

<style scoped lang="scss">
  .empty-report{
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-disabled;
    font-size: 20px;
    font-weight: 500;
    @include breakpoint-min(sm) {
      height: calc(100vh - 80px);
    }

    .icon{
      font-size: 2.5em;
      &:hover{
        color: inherit;
        cursor: inherit;
      }
    }
  }
</style>
